module.exports = __webpack_public_path__ + "static/media/拼车合乘.ab0f9b9e.jpg";